import { render, staticRenderFns } from "./JobTaskSummary.vue?vue&type=template&id=272faa42&scoped=true&"
import script from "./JobTaskSummary.vue?vue&type=script&lang=js&"
export * from "./JobTaskSummary.vue?vue&type=script&lang=js&"
import style0 from "./JobTaskSummary.vue?vue&type=style&index=0&id=272faa42&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "272faa42",
  null
  
)

export default component.exports